export default __webpack_public_path__ + "static/media/first.a6acc9dc.svg";